import { colors, LIGHT_THEME, spacing, ThemeShape } from '@codility/rondo-ui';
import { css } from 'styled-components';
import { breakpoints } from '../utils/media-queries';

export const landingPageTheme = (backgroundColor?: string): ThemeShape => ({
  ...LIGHT_THEME,
  customComponents: {
    backdrop: css`
      background-color: #000000;
      opacity: 70%;
    `,
    modal: css`
      background-color: ${LIGHT_THEME.background};
      padding: ${spacing.spacing32};
      border-radius: 4px;
    `,
  },
  landingPage: {
    highlightedSectionColor: backgroundColor || colors.ultramarine100,
    languagePillColor: colors.lemon400,
  },
  components: {
    ...LIGHT_THEME.components,
    atoms: {
      ...LIGHT_THEME.components.atoms,
      typography: {
        ...LIGHT_THEME.components.atoms.typography,
        basic: css`
          ${LIGHT_THEME.components.atoms.typography.basic}
          font-size: 1rem;
          line-height: 1.6875rem;
        `,
        heading1: css`
          ${LIGHT_THEME.components.atoms.typography.heading2}
          font-size: 2.25rem;
          line-height: 2.5rem;
          font-weight: 700;
        `,
        heading2: css`
          ${LIGHT_THEME.components.atoms.typography.heading2}
          font-size: 1.5rem;
          line-height: 1.75rem;
          font-weight: 700;

          @media only screen and ${breakpoints.up.md} {
            font-size: 2.25rem;
            line-height: 2.5rem;
          }
        `,
      },
    },
  },
});
